import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedLayout: {
    id: "",
    title: "",
    screens_setting: [],
  },
  defaultTemplate: [],
  userTemplate: [],
  selectedTemplate: {
    id: "",
    title: "",
    screens_setting: [],
  },
  screenDetails: {},
  screens_setting: [],
  reloadTrigger: false,
  screenMedia: "",
  isPublished: "",
  layoutAspectRatio: {},
  unit: { label: "Percentage %", value: "%" },
  screen_duration: 0,
  screen_is_muted: 1,

  selectedArea: {},

  // ads feature
  isAdsOn: false,
  isAdScreen: false,
  isAnimationScreen: false,
  animationAdDetails: {},
  media_delay_duration: 3,

  adsSettings: {
    ads_delay_duration: 10,
    ads_repetition_count: 3,
    // media_delay_duration: "",
    animation_duration: 3,
  },

  // Design Tools
  designTools: {
    isPanelOpen: false,
    activeTab: 'layout', // 'layout', 'alignment', 'precision', 'visual'
    activeTool: null, // Currently selected tool for tutorial display

    // Layout Aids
    grid: {
      enabled: false,
      size: 20, // pixels
      color: '#e5e7eb',
      opacity: 0.5,
    },
    rulers: {
      enabled: false,
      unit: 'px',
    },
    guides: {
      enabled: false,
      lines: [], // { id, type: 'horizontal'|'vertical', position: number }
    },

    // Precision
    snap: {
      toGrid: false,
      toObjects: true,
      toGuides: true,
      threshold: 5,
    },

    // Visual
    zoom: {
      level: 1,
      presets: [0.25, 0.5, 0.75, 1, 1.5, 2],
    },
  },
};

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setIsAdsOn(state, action) {
      state.isAdsOn = action.payload;
    },
    setMediaDelayDuration(state, action) {
      state.media_delay_duration = action.payload;
    },
    setIsAdScreen(state, action) {
      state.isAdScreen = action.payload;
    },
    setIsAnimationScreen(state, action) {
      state.isAnimationScreen = action.payload;
    },
    setAdsSettings: (state, action) => {
      state.adsSettings = { ...state.adsSettings, ...action.payload };
    },
    setAnimationAdDetails(state, action) {
      state.animationAdDetails = action.payload;
    },

    // Design Tools Actions
    toggleDesignToolsPanel(state) {
      state.designTools.isPanelOpen = !state.designTools.isPanelOpen;
    },
    setDesignToolsTab(state, action) {
      state.designTools.activeTab = action.payload;
    },
    setActiveTool(state, action) {
      state.designTools.activeTool = action.payload;
    },
    toggleGrid(state) {
      state.designTools.grid.enabled = !state.designTools.grid.enabled;
    },
    setGridSize(state, action) {
      state.designTools.grid.size = action.payload;
    },
    toggleRulers(state) {
      state.designTools.rulers.enabled = !state.designTools.rulers.enabled;
    },
    toggleGuides(state) {
      state.designTools.guides.enabled = !state.designTools.guides.enabled;
    },
    addGuide(state, action) {
      state.designTools.guides.lines.push(action.payload);
    },
    removeGuide(state, action) {
      state.designTools.guides.lines = state.designTools.guides.lines.filter(
        guide => guide.id !== action.payload
      );
    },
    updateGuide(state, action) {
      const { id, position } = action.payload;
      const guide = state.designTools.guides.lines.find(g => g.id === id);
      if (guide) guide.position = position;
    },
    toggleSnapToGrid(state) {
      state.designTools.snap.toGrid = !state.designTools.snap.toGrid;
    },
    toggleSnapToObjects(state) {
      state.designTools.snap.toObjects = !state.designTools.snap.toObjects;
    },
    toggleSnapToGuides(state) {
      state.designTools.snap.toGuides = !state.designTools.snap.toGuides;
    },
    setZoomLevel(state, action) {
      state.designTools.zoom.level = action.payload;
    },

    //
    setSelectedLayout(state, action) {
      state.selectedLayout = action.payload;
    },
    setUnit(state, action) {
      state.unit = action.payload;
    },
    setLayoutAspectRatio(state, action) {
      state.layoutAspectRatio = action.payload;
    },
    updateSelectedLayoutTitle(state, action) {
      state.selectedLayout.title = action.payload;
    },
    setSelectedTemplate(state, action) {
      state.selectedTemplate = action.payload;
    },
    setDefaultTemplate(state, action) {
      state.defaultTemplate = action.payload;
    },
    setUserTemplate(state, action) {
      state.userTemplate = action.payload;
    },
    addToUserTemplate(state, action) {
      const newTemplate = {
        id: action.payload.id,
        title: action.payload.title,
        screens_setting: action.payload.screens_setting,
      };
      state.userTemplate.push(newTemplate);
    },

    setScreenDetails(state, action) {
      state.screenDetails = action.payload;
    },
    setScreenMedia(state, action) {
      state.screenMedia = action.payload;
    },
    setScreens_setting(state, action) {
      state.screens_setting = action.payload;
    },
    setReloadTrigger(state, action) {
      state.reloadTrigger = action.payload;
    },
    setIsPublished(state, action) {
      state.isPublished = action.payload;
    },
    updateCampaignDuration(state, action) {
      if (state.screenDetails) {
        state.screen_duration = action.payload;
      }
    },
    updateCampaignMuted(state, action) {
      if (state.screenDetails) {
        state.screen_is_muted = action.payload;
      }
    },
    setSelectedArea(state, action) {
      state.selectedArea = action.payload;
    },
    resetState: (state) => {
      state.selectedLayout = {
        id: "",
        title: "",
        screens_setting: [],
      };
      state.adsSettings = {
        ads_delay_duration: 10,
        ads_repetition_count: 3,
        animation_duration: 3,
      };

      state.isAdsOn = false;
      state.isAdScreen = false;
      state.isAnimationScreen = false;
      state.animationAdDetails = {};
      state.media_delay_duration = 3;

      state.screenDetails = {};
      state.screens_setting = [];
      state.layoutAspectRatio = {};
    },
  },
});

export const {
  setSelectedLayout,
  setUnit,
  setLayoutAspectRatio,
  updateSelectedLayoutTitle,
  setScreenMedia,
  setSelectedTemplate,
  setDefaultTemplate,
  setUserTemplate,
  addToUserTemplate,
  setScreenDetails,
  setScreens_setting,
  setReloadTrigger,
  setIsPublished,
  updateCampaignDuration,
  updateCampaignMuted,

  setSelectedArea,
  resetState,

  setIsAdsOn,
  setIsAdScreen,
  setMediaDelayDuration,
  setIsAnimationScreen,
  setAdsSettings,
  setAnimationAdDetails,
} = layoutSlice.actions;

export default layoutSlice.reducer;
